// extracted by mini-css-extract-plugin
module.exports = {"component":"Loading_component__1BVLF","small":"Loading_small__yd7lU","spinner":"Loading_spinner__UQO_S","spin":"Loading_spin__kRfhz"};